import { StepUpProviderRef } from 'pbts/c1/api/stepup/v1/stepup'
import { StepUpProviderServiceClient } from 'pbts/c1/api/stepup/v1/stepup.client'
import { createMutationApi } from './lib/createMutationApi'
import { createPagedListApi } from './lib/createPagedListApi'
import { createUnaryApi } from './lib/createUnaryApi'

// List Step Up Providers - using createPagedListApi
export const listStepUpProvidersApi = createPagedListApi(
    StepUpProviderServiceClient,
    'list',
    undefined,
    StepUpProviderRef.typeName,
)

// Search Step Up Providers - using createPagedListApi
export const searchStepUpProvidersApi = createPagedListApi(
    StepUpProviderServiceClient,
    'search',
    undefined,
    StepUpProviderRef.typeName,
)

// Get a single Step Up Provider
export const getStepUpProviderApi = createUnaryApi(
    StepUpProviderServiceClient,
    'get',
)

// Create a Step Up Provider
export const createStepUpProviderApi = createMutationApi(
    StepUpProviderServiceClient,
    'create',
    undefined,
    StepUpProviderRef.typeName,
)

// Update a Step Up Provider
export const updateStepUpProviderApi = createMutationApi(
    StepUpProviderServiceClient,
    'update',
    undefined,
    StepUpProviderRef.typeName,
)

// Update a Step Up Provider's secret
export const updateStepUpProviderSecretApi = createMutationApi(
    StepUpProviderServiceClient,
    'updateSecret',
)

// Delete a Step Up Provider
export const deleteStepUpProviderApi = createMutationApi(
    StepUpProviderServiceClient,
    'delete',
    undefined,
    StepUpProviderRef.typeName,
)

// Test a Step Up Provider
export const testStepUpProviderApi = createUnaryApi(
    StepUpProviderServiceClient,
    'test',
)
